import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

type SwitchButtonProps = {
  label?: React.ReactNode;
  children?: React.ReactNode;
  checked?: boolean;
  onClick?: () => void;
  tooltip?: React.ReactNode;
  labelClassName?: string;
  checkedClassName?: string;
  textClassName?: string;
  size?: number;
};

const SwitchButton = ({
  label,
  children,
  checked,
  onClick,
  tooltip,
  labelClassName,
  checkedClassName,
  textClassName,
  size = 16,
}: SwitchButtonProps) => {
  return (
    <OverlayTrigger overlay={tooltip ? <Tooltip>{tooltip}</Tooltip> : <></>}>
      <label
        className={twMerge("flex items-center cursor-pointer", labelClassName)}
        onClick={onClick}
      >
        {(children || label) && (
          <div
            className={twMerge("text-active-black mr-[10px]", textClassName)}
          >
            {children || label}
          </div>
        )}
        <div
          className={twMerge(
            "relative rounded-full transition ease-in-out duration-700",
            "border border-solid border-shady-gray",
            checked ? twMerge("bg-smart-teal", checkedClassName) : "bg-white"
          )}
          style={{ height: size + 3, width: size * 2 - 1 }}
        >
          <div
            className={twMerge(
              "absolute rounded-full bg-white shadow shadow-black"
            )}
            style={{ width: size, height: size, left: checked ? size - 3 : 0 }}
          ></div>
        </div>
      </label>
    </OverlayTrigger>
  );
};

export default SwitchButton;
